import { RegexEditor } from '../utils/regex_editor'
import { paragraph } from './paragraph'

const _blockquote = /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/

export const blockquote = new RegexEditor(_blockquote)
  .replace('paragraph', paragraph)
  .getRegex()
